//import React, { createContext, useContext, useState, useEffect } from 'react';
import { BusinessContext } from '@/apps/providers/BusinessContext';
import { useAnalytics } from './useAnalytics';

const ChatContext = React.createContext();

export const useChat = () => {
  const context = React.useContext(ChatContext);
  if (!context) {
    throw new Error('useChat must be used within a ChatProvider');
  }
  return context;
};

export const ChatProvider = ({ children }) => {
  const { selectedBusiness: business, selectedMenu: menu } = React.useContext(BusinessContext);
  const analytics = useAnalytics();
  const [isOpen, setIsOpen] = React.useState(false);
  const [sessionId, setSessionId] = React.useState(null);
  const [unreadCount, setUnreadCount] = React.useState(0);

  // Load session from localStorage on mount
  React.useEffect(() => {
    const savedSessionId = localStorage.getItem('chat_session_id');
    if (savedSessionId) {
      setSessionId(savedSessionId);
    }
  }, []);

  // Save session to localStorage when it changes
  React.useEffect(() => {
    if (sessionId) {
      localStorage.setItem('chat_session_id', sessionId);
    }
  }, [sessionId]);

  const openChat = () => {
    setIsOpen(true);
    setUnreadCount(0);
    analytics.trackChatOpened(); // Track analytics
  };

  const closeChat = () => {
    setIsOpen(false);
  };

  const toggleChat = () => {
    if (isOpen) {
      closeChat();
    } else {
      openChat();
    }
  };

  return (
    <ChatContext.Provider
      value={{
        isOpen,
        setIsOpen,
        openChat,
        closeChat,
        toggleChat,
        sessionId,
        setSessionId,
        business,
        menu,
        unreadCount,
        setUnreadCount,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
};
